module.exports = __webpack_public_path__ + "img/海南生态软件园.cd843962.png";